<div class="custom-background">
    <div class="row logo-margin">
        <div class="col-12 text-center">
            <img class="logo" src="./assets/images/logos/logo_bankei.png">
        </div>
    </div>

    <app-new-alert></app-new-alert>

    <div class="row container-fluid">
        <div class="col-lg-6 col-md-6 col-sm-12 text-center m-auto">
            <div class="title">Suas empresas</div>
            <div class="subtitle mt-3">Escolha uma empresa para gerenciar agora</div>
            <form [formGroup]="selectAssignorFormGroup" #selectAssignorForm="ngForm" (ngSubmit)="onSubmit()">

                <div class="div-select my-5 col-7 mx-auto">
                    <div *ngIf="form.cedente.invalid && (form.cedente.dirty || form.cedente.touched)" class="custom-text-danger">
                        <div *ngIf="form.cedente.errors.required">
                            Por favor selecione a empresa cedente
                        </div>
                    </div>
                    <select formControlName="cedente">
                        <option disabled value="">Selecione a empresa</option>
                        <option *ngFor="let item of cedentes" [value]="item.transitoryToken">{{item.assignorName}}</option>
                    </select>
                </div>

                <div class="row custom-button-container">
                    <div class="col-12 d-flex justify-content-center">
                        <button [disabled]="!selectAssignorForm.valid" type="submit" class="login-button-submit">
                            <span>Entrar</span>
                            <!-- <img src="./assets/icons/arrow-right.svg"> -->
                        </button>
                        <!-- <button [disabled]="!selectAssignorForm.valid" type="submit" class="custom-button">Entrar</button> -->
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
